<template>
    <iframe
        style="width: 100%; height: 84vh; border: 0; padding-top: 10px"
        :src="workflowUrl"
    />
</template>
<script>
import { WORKFLOW_UI } from "@/config";

export default {
    data() {
        return {
            token: null,
        };
    },
    computed: {
        workflowUrl() {
            const baseUrl = `${WORKFLOW_UI}/workflows/new?flat=true`;
            return this.token ? `${baseUrl}&auth=${this.token}` : baseUrl;
        },
    },
    created() {
        const userData = sessionStorage.getItem("userLogin");
        this.token = userData ? JSON.parse(userData).token : null;
    },
};
</script>
